import React, { useEffect, useRef, useState } from "react";

/**
 * Animated integer count-up. Uses requestAnimationFrame + easeOutCubic.
 * Formats with locale thousands separators.
 */
export function CountUp({ value = 0, duration = 1400, prefix = "", suffix = "", decimals = 0, className = "", testid }) {
    const [display, setDisplay] = useState(0);
    const rafRef = useRef();
    const startRef = useRef();

    useEffect(() => {
        const from = 0;
        const to = Number(value) || 0;
        const startTs = performance.now();
        startRef.current = startTs;

        const tick = (now) => {
            const elapsed = now - startTs;
            const t = Math.min(1, elapsed / duration);
            // easeOutCubic
            const eased = 1 - Math.pow(1 - t, 3);
            const current = from + (to - from) * eased;
            setDisplay(current);
            if (t < 1) rafRef.current = requestAnimationFrame(tick);
        };
        rafRef.current = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(rafRef.current);
    }, [value, duration]);

    const formatted = display.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    return (
        <span data-testid={testid} className={className}>
            {prefix}{formatted}{suffix}
        </span>
    );
}
